/**
 * Step: Invite your team (BLU-1376, Q2). The optional last step of both flows.
 *
 * Shown only to people who can invite (`can('users.manage')`, the invite
 * procedures' own gate), always open, with Mark as done and no Skip. It never
 * counts toward finishing setup (`OPTIONAL_STEP_IDS`), so a new org finishes
 * with this step still To do.
 *
 * The body is the Settings user management, reused as is, so setup mode never
 * needs `/settings` on its allowlist. In the client flow its dialogs run in
 * client mode (one login type, written as Admin, labelled Client): a client
 * org has no floor of its own, so a floor role it created could not sign in.
 * Otherwise the prop is omitted and the screen follows the server's verdict
 * exactly as Settings does. Mounted only while selected (the page lazy-mounts
 * the selected pane), so its user and invite reads run only then.
 */
import { useTranslation } from 'react-i18next';
import UserManagement from '@/features/user-management/components/UserManagement';
import { StepPane } from '../shell/StepPane';

interface StepInviteTeamProps {
  /** The wizard runs the client flow: the invite dialogs run in client mode. */
  clientMode: boolean;
}

export function StepInviteTeam({ clientMode }: StepInviteTeamProps) {
  const { t } = useTranslation('onboarding');

  return (
    <StepPane title={t('stepInviteTeam.title')} description={t('stepInviteTeam.description')}>
      <UserManagement clientMode={clientMode ? true : undefined} />
    </StepPane>
  );
}
